/* @flow */

import * as React from 'react';
import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import { get } from 'lodash/fp';
import glamorous from 'glamorous';
import { padding } from 'polished';

type Props = {
  children?: any,
  className?: string,
  history: Object,
  referrer?: string
};

const defaultProps = {
  children: undefined,
  className: undefined,
  referrer: undefined
};

const BackButton = glamorous.a(({ theme }) => ({
  flexBasis: 'auto',
  flexGrow: 0,
  flexShrink: 0,
  fontSize: theme.fontSize.medium,
  lineHeight: 1,
  ...padding(0, theme.spacing.small)
}));

function BackToReferrerArrow({ children, className, history, referrer }: Props) {
  return (
    <React.Fragment>
      {referrer && (
        <BackButton onClick={history.goBack} className={className}>
          <span className="ion-ios-arrow-back" />
        </BackButton>
      )}
      {children}
    </React.Fragment>
  );
}

BackToReferrerArrow.defaultProps = defaultProps;

const enhancer = compose(
  withRouter,
  withProps(({ location }) => ({
    referrer: get('state.referrer', location)
  }))
);

export default enhancer(BackToReferrerArrow);
